<template>
  <q-footer class="row flex-center text-white full-width footer">
    <div class="col-md-2 col-sm-12 q-py-md q-px-md">
      <div class="row justify-center" style="font-size: 11px"></div>
    </div>
  </q-footer>
</template>
<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { copyToClipboard, Notify } from "quasar";
@Component
export default class TheFooter extends Vue {
  private copiarClipboard(texto: any) {
    copyToClipboard(texto)
      .then(() => {
        Notify.create({
          color: "positive",
          message: "Se ha copiado el Número de Teléfono.",
          icon: "report_problem",
          position: "top",
          timeout: 2500,
        });
        return;
      })
      .catch(() => {
        Notify.create({
          color: "negative",
          message: "Ha ocurrido un problema. Por favor, inténtelo de nuevo.",
          icon: "report_problem",
          position: "top",
          timeout: 2500,
        });
        return;
      });
  }

  private llamar(data: any) {
    const numero = data;
    window.open("tel:" + numero);
  }
}
</script>
<style lang="scss" scoped>
@import "../../scss/colores.module";
.footer {
  min-height: 75px;
  background-color: $color-primario-uno;
}
.mc-logo {
  height: 11px;
  margin-right: 5px;
}
.phone-footer {
  @media (max-width: 1024px) {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
}
</style>
